import { useEffect, useState } from "react";
import { useUserStore } from "../../../contexts/userStore";
import UnitsConfigsService from "../../../services/UnitsConfigsService";
import FormBatchUnits from "../FormBatchUnits/FormBatchUnits";
import "./CadastroBatchUnits.css";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import { useParams } from "react-router-dom";
import TagService from "../../../services/TagService";

const CadastroBatchUnits = () => {
  const [unitsConfigs, setUnitsConfigs] = useState([]);
  const { selectedCondominio } = useUserStore();
  const params = useParams();
  const [tag, setTag] = useState(null);

  async function fetchTag(externalId) {
    try {
      const response = await TagService.getTag(externalId);
      if (response.status === 200) {
        setTag(response.data);
      }
    } catch (error) {
      console.error("Error fetching tag:", error);
    }
  }

  useEffect(() => {
    if (params.tagExternalId) {
      fetchTag(params.tagExternalId);
    }
  }, [params.tagExternalId]);

  const getUnitsConfigs = async (selectedCondominio) => {
    const response =
      await UnitsConfigsService.getCondominiumUnitsConfigs(selectedCondominio);
    setUnitsConfigs(response.data);
  };

  useEffect(() => {
    getUnitsConfigs(selectedCondominio);
  }, [selectedCondominio]);

  return (
    <CadastroContainer>
      <FormBatchUnits unitsConfigs={unitsConfigs} tag={tag} />
    </CadastroContainer>
  );
};

export default CadastroBatchUnits;
